import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@jetpack-labs/jetpack-ui/style.css'
import './style.css'
import JetpackUI from '@jetpack-labs/jetpack-ui'
import App from './App.vue'
import router from './router'

createApp(App).use(createPinia()).use(router).use(JetpackUI).mount('#app')
